import { CurrenciesToCreateProps } from '../types/currenciesToCreate.types';
import walletsThatCanBeCreated from './walletsThatCanBeCreated';

const currenciesToCreate = ({
  walletsAleadyActive,
  translations,
}: CurrenciesToCreateProps): string => {
  const availableWallets = walletsThatCanBeCreated(walletsAleadyActive);

  if (availableWallets.length === 0) return '';
  if (availableWallets.length === 1) return availableWallets[0];

  const allWalletsExceptLast = availableWallets.slice(0, -1).join(', ');
  const lastWallet = availableWallets.slice(-1);

  return `${allWalletsExceptLast} ${translations(
    'availableWalletsToCreateConnectors'
  )} ${lastWallet}`;
};

export default currenciesToCreate;
